import { render, staticRenderFns } from "./LanguageProficiencies.vue?vue&type=template&id=3441a9b2"
import script from "./LanguageProficiencies.vue?vue&type=script&lang=js"
export * from "./LanguageProficiencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports